import { BASE_API_URL } from "../config"

const CACHE_SECONDS = 0

const basicDomains = {}

// var BASE_URL='http://localhost:4000/api/v1';
// var BASE_URL='http://192.168.2.84:3000/api/v1';
// var BASE_URL = 'https://dev.tigg.app/api/v1/user';
var BASE_URL = BASE_API_URL

if (process.env.NODE_ENV == "production") {
  // BASE_URL='https://dev.tigg.app/api/v1' q
  // BASE_URL='http://localhost:4000/api/v1';
}
const networkDomains = {
  user: {
    url: {
      me: () => `${BASE_URL}/get-me`,
      edit: () => `${BASE_URL}/edit-me`,
      list_namespace: () => `${BASE_URL}/namespaces`,
      send_invite: ({ identifier }) =>
        `${BASE_URL}/${identifier}/namespace-invite`,
      namespace_invitations: () => `${BASE_URL}/invitations`,
      respond_to_invitation: () => `${BASE_URL}/respond-to-invitation`,
      attachments: () => `${BASE_URL}/attachments`,
      leave_company: () => `${BASE_URL}/leave-company`,
      enable_2fa: () => `${BASE_URL}/enable-2fa`,
      validate_referral_code: () => `${BASE_URL}/validate-referral-code`,
      // disable_2fa: () => `${BASE_URL}/disable-2fa`,
    },
  },

  register: {
    url: {
      register_user: () => `${BASE_URL}/user-registration`,
      register: () => `${BASE_URL}/user-registration-qualify`,
      resend_otp: () => `${BASE_URL}/user-registration-resend-otp`,
      verify_code: () => `${BASE_URL}/user-registration-verify`,
      namespace_register: () => `${BASE_URL}/namespace-requests`,
      namespace_requests: ({ identifier }) =>
        `${BASE_URL}/namespace-requests/${identifier}`,
      cancel: ({ identifier }) =>
        `${BASE_URL}/namespace-requests/${identifier}/cancel`,
      slug_check: () => `${BASE_URL}/check-namespace-requests`,
    },
  },

  password: {
    url: {
      send_email: () => `${BASE_URL}/get-forget-password-link`,
      reset_password: ({ identifier }) =>
        `${BASE_URL}/forget-password${identifier}`,
      change_password: () => `${BASE_URL}/change-password`,
      check_expiry: () => `${BASE_URL}/check-link`,
    },
  },
  upgradeCredentials: {
    url: {
      upgrade_credentials: () => `${BASE_URL}/upgrade-credentials`,
    },
  },

  fileUpload: {
    url: {
      upload: () => `${BASE_URL}/upload-file`,
      download: () => `${BASE_URL}/download-file`,
      generate_upload_url: () => `${BASE_URL}/generate-upload-url`,
    },
  },

  trustedDevices: {
    url: {
      list: () => `${BASE_URL}/trusted-devices`,
      detail: ({ identifier }) => `${BASE_URL}/trusted-devices/${identifier}`,
      remove_all: () => `${BASE_URL}/sessions`,
    },
  },

  blogs:{
    require_auth: false,
    url:{
      getBlogs:()=>`${BASE_URL}/cms-collections`
    }
  },

  dynamic: {
    // urls used for dynamic selection
    url: {},
  },
}

export { basicDomains, networkDomains }
